export default __webpack_public_path__ + "static/media/removed-submission.143eaf67.svg";